import { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_ONLINE_BOOK } from "../../../Schema/OnlineBook";
import { useDeleteImageServer } from "../../CropImage/DeleteImageServer";

const useDeleteLesson = ({ handleClose, setRefetch, editData }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const mutationDelete = useDeleteImageServer();

  const [deleteOnlineBook] = useMutation(DELETE_ONLINE_BOOK, {
    onCompleted: ({ deleteOnlineBook }) => {
      setLoading(false);
      if (deleteOnlineBook?.isSuccess === true) {
        setAlert(true, "success", deleteOnlineBook?.message);
        handleClose();
        setRefetch();

        if (editData?.image) {
          let splitSrc = editData?.image?.split(":")[4];
          mutationDelete.mutate({
            storage: "sr_music_academy",
            folder: "sr_music_images",
            file: splitSrc.split("/")[0],
          });
        }
      } else {
        setAlert(true, "error", deleteOnlineBook?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteOnlineBook({
      variables: {
        id: editData?._id,
      },
    });
  };

  return { deleteOnlineBook, loading, setLoading, handleDelete };
};

export default useDeleteLesson;
